import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStackoverflowComponent } from './simple-icons-stackoverflow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStackoverflowComponent ],
    exports:      [ SimpleIconsStackoverflowComponent ],
    bootstrap:    []
})
export class SimpleIconsStackoverflowModule {}
